import React, {useState } from "react";
import styles from "./songratingslider.module.scss";
import Slider from '@mui/material/Slider';
import { logEvent } from "analyticsEvents";
import { Box } from "@material-ui/core";


interface Props {
  songId: string,
  onValueChanged: (newRating: number) => void
}

const SongRatingSlider = (props: Props) => {
  const [value, setValue] = useState(1.2);
  const [hasDragged, setHasDragged] = useState(false);

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
    <div hidden={hasDragged} className={styles.rateItText}><p>RATE IT!</p></div>
    <div className={styles.ratingIndicatorWrapper} hidden={!hasDragged}
        style={{marginLeft: `calc(${value * 10}% - ${value / 10 * 56}px)`}}>
          <p className={styles.ratingEmojiText}>{getEmoji(value)}</p>
          <p className={styles.ratingIndicatorText}>{value.toFixed(1).replace(/(\.0+|0+)$/, '')}</p>
    </div>
    <div className={styles.ratingSliderRoot}>
      <Slider
        size="medium"
        min={0}
        max={10}
        defaultValue={0}
        step={.01}
        onChange={(_, value) => {
          setValue(value as number);
          setHasDragged(true);
          props.onValueChanged(value as number);
        }}
        onChangeCommitted={(_, value) => {
          logEvent('rating_changed', {
            song_id: props.songId,
            rating_position: value,
            rating_ui_variant: 'slider'
          });
        }}
        value={value}
        sx={{
          color: 'rgba(220,220,220,0.95)',
          height: 50,
          '& .MuiSlider-thumb': {
            width: 50,
            height: 50,
            backgroundColor: "#fff",
            border: '1.30769px solid rgba(0, 0, 0, 0.23)',
            '&:hover, &.Mui-focusVisible, &.Mui-active': {
              boxShadow: 'none',
            },
          },
          '& .MuiSlider-rail': {
            opacity: 0.28,
            borderRadius: '26px'
          },
          '& .MuiSlider-track': {
            background: 'linear-gradient(90deg, #428DF4 0, #9E60B9 75px, #E5666D 150px, #FFAE31 225px, #C2E240 300px)',
            borderRadius: '26px 0 0 26px'
          }
        }}
      />
      <p className={styles.dragToRateText} hidden={hasDragged}>drag to rate ☠️</p>
    </div>
    </Box>
  )
}

const getEmoji = (value: number) => {
  if (value < 2) return "💩";
  if (value < 4) return "🗑️";
  if (value < 6) return "🤷";
  if (value < 8) return "🌶️";
  if (value < 9) return "⛽";
  return "🔥";
}

export default SongRatingSlider
